import { grey } from "@mui/material/colors";
import { isNil, isNumber } from "lodash";
import { useSelector } from "react-redux";
import { formatDateShort } from "../../../utils/dates/formatDateShort";
import { getUserFullNameFromEmail } from "../../../utils/functions/getUserFullNameFromEmail";
import Flx from "../../layout/Flx";
import Txt from "../../typography/Txt";

const CellRendererAppLink = ({ loanPipeline, params }) => {
  const users = useSelector((state) => state.users);
  const app_link = params?.value;
  const salesperson = app_link?.salesperson;
  const createdBy = app_link?.link_created_by;
  const createdDate = app_link?.link_created_date;

  const formattedCreatedBy = getUserFullNameFromEmail(users, createdBy);
  const formattedSalesperson = getUserFullNameFromEmail(users, salesperson);
  const formattedCreatedDate = formatDateShort(createdDate);
  const loanNumbervalueFormatter = (params) => {
    const dealId = params?.data?.dealId;
    if (isNil(dealId)) {
      return null;
    }

    if (isNil(loanPipeline)) {
      return null;
    }
    const loanNumber = loanPipeline?.find((d) => d?._id === dealId)?.loanNumber;

    if (isNumber(loanNumber)) {
      return loanNumber;
    }
    // console.log("loanNumberloanNumber", loanNumber);
    return "loanNumbereee";
  };

  const loanNumber = loanNumbervalueFormatter(params);

  return (
    <Flx
      gap={1}
      column
      sx={{
        paddingTop: "8px",
        paddingBottom: "8px",
        ".txt": {
          fontSize: "11px",
        },
      }}
    >
      <ChipItem>
        <Txt>Created By:</Txt>
        <Txt bold>{formattedCreatedBy || "Unknown"}</Txt>
        <Txt>on</Txt>
        <Txt bold>{formattedCreatedDate || "Unknown"}</Txt>
      </ChipItem>
      <Flx ac gap={0.5}>
        <ChipItem>
          <Txt>Loan #:</Txt>
          <Txt bold>{loanNumber || "Unknown"}</Txt>
        </ChipItem>
        <ChipItem>
          <Txt>Salesperson:</Txt>
          <Txt bold>{formattedSalesperson || "Unknown"}</Txt>
        </ChipItem>
      </Flx>
    </Flx>
  );
};

const ChipItem = ({ children }) => {
  return (
    <Flx
      gap={0.5}
      sx={{
        flexGrow: 0,
        px: 1,
        width: "max-content",
        background: grey[100],
        border: `1px solid ${grey[300]}`,
        borderRadius: "8px",
      }}
    >
      {children}
    </Flx>
  );
};
export default CellRendererAppLink;
